import * as R from 'ramda'
import { createSelector } from 'reselect'

const usernameSelector = state => state.admin.createClient.username
const nameSelector = state => state.admin.createClient.name
const emailSelector = state => state.admin.createClient.email
const formSelector = state => state.admin.createClient

export {
  usernameSelector,
  nameSelector,
  emailSelector,
  formSelector
}
